<template>
  <div>
  <el-table
    :data="userlist"
    style="width: 100%">
    <el-table-column type="expand">
      <template slot-scope="props">
        <el-form label-position="left" inline class="demo-table-expand">
          <el-form-item label="姓名">
            <span>{{ props.row.name }}</span>
          </el-form-item>
          <el-form-item label="邮箱">
            <span>{{ props.row.email }}</span>
          </el-form-item>
          <el-form-item label="手机号">
            <span>{{ props.row.phone }}</span>
          </el-form-item>
          <el-form-item >

          </el-form-item>
          <el-form-item label="游戏截图">
            <div class="block" v-for="pic in props.row.gmpic" :key="pic">
              <el-image
                style="width: 100px; height: 100px"
                :src="pic"
                :preview-src-list="props.row.gmpic"></el-image>
            </div>
          </el-form-item>
          <el-form-item >
          </el-form-item>
          <el-form-item label="证据截图">
            <div class="block" v-for="pic in props.row.zjpic" :key="pic">
              <el-image
                style="width: 100px; height: 100px"
                :src="pic"
                :preview-src-list="props.row.zjpic"></el-image>
            </div>
          </el-form-item>
          <el-form-item >
          </el-form-item>
          <el-form-item label="描述">
            <span>{{ props.row.xxdesc }}</span>
          </el-form-item>
        </el-form>
      </template>
    </el-table-column>
    <el-table-column
      label="姓名"
      prop="name">
    </el-table-column>
    <el-table-column
      label="邮箱"
      prop="email">
    </el-table-column>
    <el-table-column
      label="手机号"
      prop="phone">
    </el-table-column>
    <el-table-column
      label="提交时间"
      prop="createdTime">
    </el-table-column>



  </el-table>
  <!-- 分页模块 -->
  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                 :current-page="queryInfo.current" :page-sizes="[1, 2, 5, 10]"
                 :page-size="queryInfo.size" :total="total"
                 :current-page.sync="queryInfo.current"
                 :page-size.sync="queryInfo.size"

                 layout="total, sizes, prev, pager, next, jumper">
  </el-pagination>
  </div>
</template>

<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>

<script>


  export default {

    data () {

      return {

// 获取用户列表的参数对象
        queryInfo: {
          query: '',
          // 当前的页数
          current: 1,
          // 当前每页显示多少条数据
          size: 10
        },
        total: 0,
        userlist: []
      }
    },
    created:function(){
      this.handleCurrentChange (1)
    },
    methods: {
      // 获取用户信息
      async getUserList () {
        const { data: res } = await this.$axios.post('https://qyxx.xmqiyou.com/jb/conditions', this.queryInfo )
        if (res.code !== '000000') {
          return this.$message.error('获取举报列表失败')
        }
        this.userlist = res.data.records
        this.total = res.data.total
      },
      // 监听 pagesize 改变的事件
      handleSizeChange (newSize) {
        // 同步修改data中的pagesize
        this.queryInfo.size = newSize
        // 重新发起数据请求
        this.getUserList()
      },
      // 监听 页码值 改变的事件
      handleCurrentChange (newPage) {
        this.queryInfo.current = newPage
        this.getUserList()
      }
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/views/hsmj/jbList.vue